/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetServerScopePinRequestBody,
  SetServerScopePinRequestBody$Outbound,
  SetServerScopePinRequestBody$outboundSchema,
} from "../components/setserverscopepinrequestbody.js";

export type SetRemoteMcpServerScopePinSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetRemoteMcpServerScopePinSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetRemoteMcpServerScopePinSecurity = {
  option1?: SetRemoteMcpServerScopePinSecurityOption1 | undefined;
  option2?: SetRemoteMcpServerScopePinSecurityOption2 | undefined;
};

export type SetRemoteMcpServerScopePinRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setServerScopePinRequestBody: SetServerScopePinRequestBody;
};

/** @internal */
export type SetRemoteMcpServerScopePinSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetRemoteMcpServerScopePinSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetRemoteMcpServerScopePinSecurityOption1$Outbound,
    SetRemoteMcpServerScopePinSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setRemoteMcpServerScopePinSecurityOption1ToJSON(
  setRemoteMcpServerScopePinSecurityOption1:
    SetRemoteMcpServerScopePinSecurityOption1,
): string {
  return JSON.stringify(
    SetRemoteMcpServerScopePinSecurityOption1$outboundSchema.parse(
      setRemoteMcpServerScopePinSecurityOption1,
    ),
  );
}

/** @internal */
export type SetRemoteMcpServerScopePinSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetRemoteMcpServerScopePinSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetRemoteMcpServerScopePinSecurityOption2$Outbound,
    SetRemoteMcpServerScopePinSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setRemoteMcpServerScopePinSecurityOption2ToJSON(
  setRemoteMcpServerScopePinSecurityOption2:
    SetRemoteMcpServerScopePinSecurityOption2,
): string {
  return JSON.stringify(
    SetRemoteMcpServerScopePinSecurityOption2$outboundSchema.parse(
      setRemoteMcpServerScopePinSecurityOption2,
    ),
  );
}

/** @internal */
export type SetRemoteMcpServerScopePinSecurity$Outbound = {
  Option1?: SetRemoteMcpServerScopePinSecurityOption1$Outbound | undefined;
  Option2?: SetRemoteMcpServerScopePinSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetRemoteMcpServerScopePinSecurity$outboundSchema: z.ZodMiniType<
  SetRemoteMcpServerScopePinSecurity$Outbound,
  SetRemoteMcpServerScopePinSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetRemoteMcpServerScopePinSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetRemoteMcpServerScopePinSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setRemoteMcpServerScopePinSecurityToJSON(
  setRemoteMcpServerScopePinSecurity: SetRemoteMcpServerScopePinSecurity,
): string {
  return JSON.stringify(
    SetRemoteMcpServerScopePinSecurity$outboundSchema.parse(
      setRemoteMcpServerScopePinSecurity,
    ),
  );
}

/** @internal */
export type SetRemoteMcpServerScopePinRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetServerScopePinRequestBody: SetServerScopePinRequestBody$Outbound;
};

/** @internal */
export const SetRemoteMcpServerScopePinRequest$outboundSchema: z.ZodMiniType<
  SetRemoteMcpServerScopePinRequest$Outbound,
  SetRemoteMcpServerScopePinRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setServerScopePinRequestBody: SetServerScopePinRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setServerScopePinRequestBody: "SetServerScopePinRequestBody",
    });
  }),
);

export function setRemoteMcpServerScopePinRequestToJSON(
  setRemoteMcpServerScopePinRequest: SetRemoteMcpServerScopePinRequest,
): string {
  return JSON.stringify(
    SetRemoteMcpServerScopePinRequest$outboundSchema.parse(
      setRemoteMcpServerScopePinRequest,
    ),
  );
}
